import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function MessageTemplateIcon({
  active = false,
  arrow = false,
  className = '',
  size = 24,
  title,
  ...props
}) {
  if (arrow) {
    return (
      <SvgIcon
        name="compose-arrow"
        viewBox="0 0 9 15"
        width={9}
        height={15}
        className={['message-template-arrow', 'compose-action-icon', className].filter(Boolean).join(' ')}
        title={title}
        {...props}
      />
    );
  }

  const classNames = [
    'message-template-icon',
    'compose-action-icon',
    active ? 'message-template-icon-active' : 'message-template-icon-inactive',
    className,
  ].filter(Boolean).join(' ');

  return (
    <SvgIcon
      name={active ? 'message-template-active' : 'message-template-inactive'}
      viewBox="0 0 20 20"
      size={size}
      className={classNames}
      title={title}
      {...props}
    />
  );
}
